import * as React from 'react'

export function DialogButtonsList({ children }: { children: React.ReactNode }) {
  return <div className='flex gap-3'>{children}</div>
}

export function DialogActions({
  'data-test-id': dataTestId,
  children
}: {
  'data-test-id'?: string
  children: React.ReactNode
}) {
  return (
    <div className='flex flex-col items-end mt-3 gap-3' data-test-id={dataTestId}>
      {children}
    </div>
  )
}
